// extracted by mini-css-extract-plugin
module.exports = {"attachmentFileUpload":"AttachmentFileUpload_attachmentFileUpload__Ifc4D","uploadLink":"AttachmentFileUpload_uploadLink__2ElPz"};